var _classCallCheck = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/abdulihshan/Projects/ishro-web-react-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

/** @preserve
  * package: sweetalert2-react-content v4.1.1
  * file: dist/sweetalert2-react-content.umd.js
  * homepage: https://github.com/sweetalert2/sweetalert2-react-content#readme
  * license: MIT
  **/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('react-dom')) : typeof define === 'function' && define.amd ? define(['react', 'react-dom'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.sweetalert2ReactContent = factory(global.React, global.ReactDOM));
})(this, function (React, ReactDOM) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

  var mounts = [{
    key: 'title',
    getter: function getter(swal) {
      return swal.getTitle();
    }
  }, {
    key: 'html',
    getter: function getter(swal) {
      return swal.getHtmlContainer();
    }
  }, {
    key: 'confirmButtonText',
    getter: function getter(swal) {
      return swal.getConfirmButton();
    }
  }, {
    key: 'denyButtonText',
    getter: function getter(swal) {
      return swal.getDenyButton();
    }
  }, {
    key: 'cancelButtonText',
    getter: function getter(swal) {
      return swal.getCancelButton();
    }
  }, {
    key: 'footer',
    getter: function getter(swal) {
      return swal.getFooter();
    }
  }, {
    key: 'closeButtonHtml',
    getter: function getter(swal) {
      return swal.getCloseButton();
    }
  }, {
    key: 'iconHtml',
    getter: function getter(swal) {
      return swal.getIcon().querySelector('.swal2-icon-content');
    }
  }, {
    key: 'loaderHtml',
    getter: function getter(swal) {
      return swal.getLoader();
    }
  }];

  var noop = function noop() {}; // eslint-disable-line @typescript-eslint/no-empty-function


  var error = function error(message) {
    return new Error("sweetalert2-react-content: ".concat(message));
  };

  function withReactContent(ParentSwal) {
    return /*#__PURE__*/function (_ParentSwal) {
      _inherits(_class, _ParentSwal);

      var _super = _createSuper(_class);

      function _class() {
        _classCallCheck(this, _class);

        return _super.apply(this, arguments);
      }

      _createClass(_class, [{
        key: "_main",
        value: function _main(params, mixinParams) {
          params = Object.assign({}, mixinParams, params);
          mounts.forEach(function (_ref) {
            var key = _ref.key,
                getter = _ref.getter;

            if ( /*#__PURE__*/React__default['default'].isValidElement(params[key])) {
              var reactElement = params[key];
              params[key] = ' ';
              var domElement;
              var openHookName = 'didOpen';
              var superOpenHook = params[openHookName] || noop;

              params[openHookName] = function (element) {
                domElement = getter(ParentSwal);
                domElement && ReactDOM__default['default'].render(reactElement, domElement);
                superOpenHook(element);
              };

              var destroyHookName = 'didDestroy';
              var superDestroyHook = params[destroyHookName] || noop;

              params[destroyHookName] = function (element) {
                superDestroyHook(element);

                if (domElement) {
                  ReactDOM__default['default'].unmountComponentAtNode(domElement);
                }
              };
            }
          });
          return _get(_getPrototypeOf(_class.prototype), "_main", this).call(this, params, mixinParams);
        }
      }, {
        key: "update",
        value: function update() {
          throw error('Swal.update() is not yet supported. See https://github.com/sweetalert2/sweetalert2-react-content/issues/73');
        }
      }], [{
        key: "argsToParams",
        value: function argsToParams(args) {
          if ( /*#__PURE__*/React__default['default'].isValidElement(args[0]) || /*#__PURE__*/React__default['default'].isValidElement(args[1])) {
            var params = {};
            ['title', 'html', 'icon'].forEach(function (name, index) {
              if (args[index] !== undefined) {
                params[name] = args[index];
              }
            });
            return params;
          } else {
            return ParentSwal.argsToParams(args);
          }
        }
      }]);

      return _class;
    }(ParentSwal);
  }

  return withReactContent;
});